import { render } from "./FormLabel.vue?vue&type=template&id=0b831c88"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"

import "./FormLabel.vue?vue&type=style&index=0&id=0b831c88&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__